import { aboutData } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20interior%20with%20team%20collaboration%20area%2C%20glass%20walls%2C%20warm%20natural%20lighting%2C%20professional%20business%20environment%2C%20minimal%20clean%20design%2C%20neutral%20warm%20tones%2C%20editorial%20photography%20quality&width=800&height=600&seq=about-2026-r1&orientation=landscape"
                alt="RedeemSoft corporate office"
                className="w-full h-64 md:h-80 lg:h-96 object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/60 to-transparent p-4 md:p-6">
                <p className="text-background-50 font-heading font-semibold text-base md:text-lg">
                  Iselin, New Jersey — Headquartered since 2004
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
              Who We Are
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
              {aboutData.headline}
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-8">
              {aboutData.description}
            </p>

            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {aboutData.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70"
                >
                  <div className="font-heading font-bold text-2xl md:text-3xl text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-600 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}